import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const DoubleChevronLeftIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="doubleChevronLeft" ref={ref} {...props}>
    <path d="M17.18,18a.73.73,0,0,1-.52-.21l-5.42-5.23a.75.75,0,0,1,0-1.08l5.42-5.23a.75.75,0,1,1,1,1.08L12.84,12l4.86,4.69a.75.75,0,0,1,0,1.06A.76.76,0,0,1,17.18,18Zm-4.45-.23a.75.75,0,0,0,0-1.06L7.85,12l4.86-4.69a.75.75,0,1,0-1-1.08L6.25,11.46a.75.75,0,0,0,0,1.08l5.42,5.23a.73.73,0,0,0,.52.21A.76.76,0,0,0,12.73,17.75Z" />
  </Icon>
)) as IconWithRender;

DoubleChevronLeftIcon.displayName = 'DoubleChevronLeftIcon';
DoubleChevronLeftIcon.renderIcon = (props) => (
  <DoubleChevronLeftIcon {...props} />
);
export default DoubleChevronLeftIcon;
